import Button from "../../../UI/Button";
import useScrollStop from "../../../hooks/use-scroll-stop";
import styles from "./Cart.module.css";
import CartItem from "./CartItem";
import exit from "../../../../assets/x-highlight.png";
import { useEffect, useState } from "react";
import usePostOrder from "../../../hooks/_REST API/POST/use-post-order";
import CheckoutForm from "./CheckoutForm";

export default function Cart({ cartCtx, onClose, dataCtx }) {
  useScrollStop();

  const [respStatus, setRespStatus, postOrder] = usePostOrder();
  const [isCheckingOut, setIsCheckingOut] = useState(false);

  useEffect(() => {
    if (respStatus === 2) {
      setTimeout(() => {
        setIsCheckingOut(false);
        cartCtx.items.map((item) => cartCtx.removeItem(item.id, "whole"));
        onClose();
        setRespStatus(0);
      }, [2500]);
    }
  }, [respStatus]);

  return (
    <>
      <div className={styles.backdrop} onClick={onClose} />
      {isCheckingOut && (
        <CheckoutForm
          items={cartCtx.items}
          onClose={() => {
            setIsCheckingOut(false);
          }}
          respStatus={respStatus}
          postOrder={postOrder}
          dataCtx={dataCtx}
        />
      )}

      <main className={styles.main}>
        <div className={styles.title}>{dataCtx.pageData.market.cart.title}</div>
        <img className={styles.exit} src={exit} alt="X" onClick={onClose} />
        <div className={styles[`list`]}>
          {cartCtx.items.length > 0 ? (
            cartCtx.items.map((item, key) => {
              return <CartItem key={key} item={item} cartCtx={cartCtx} />;
            })
          ) : (
            <div>{dataCtx.pageData.market.cart.empty}</div>
          )}
        </div>
        <div className={styles.actions}>
          <div className={styles[`send-button`]}>
            <Button
              onClick={() => {
                setIsCheckingOut(true);
              }}
              disabled={!cartCtx.items.length > 0 ? true : false}
            >
              {dataCtx.pageData.market.cart.buy}
            </Button>
          </div>
        </div>
      </main>
    </>
  );
}
